import React from 'react';
import {
    DiJavascript1, DiReact,
    DiNodejs, DiGithubBadge, DiMongodb
} from "react-icons/di";
import {
    SiFirebase, SiWindows, SiVisualstudiocode,
    SiPostman, SiHeroku, SiNetlify, SiExpress,
} from "react-icons/si";
import { AiFillHtml5, AiFillDatabase } from "react-icons/ai";
import { SiCss3, SiRedux } from "react-icons/si";
import { FaStripe } from "react-icons/fa";

const Skill = () => {
    return (
        <div className='py-12' id="skill">
            <h1 className='text-2xl font-bold '>
                02.<span className='text-primary'>Who_Do_I_Know</span>
                </h1>
                <h1 class="mb-4 text-base font-normal text-gray-500 dark:text-gray-400 py-2">80+ expert every skills.</h1>

            <div className='grid mt-4 justify-content-center  grid-cols-3 md:grid-cols-4 lg:grid-cols-6 gap-6'>
                <div className="skill-card-border  text-5xl grid justify-center text-[#f0db4f]"><DiJavascript1 /></div>
                <div className="skill-card-border text-5xl grid justify-center text-[#7cc5d9]"><DiReact /></div>
                <div className="skill-card-border text-5xl grid justify-center text-[#3c873a]"><DiNodejs /></div>
                <div className="skill-card-border text-5xl grid justify-center text-[#e32c26]"><AiFillHtml5 /></div>
                <div className="skill-card-border text-5xl grid justify-center text-[#589636]"><DiMongodb /></div>
                <div className="skill-card-border text-5xl grid justify-center"><SiExpress /></div>
                <div className="skill-card-border text-5xl grid justify-center text-[#f5f5f5]"><DiGithubBadge /></div>
                <div className="skill-card-border text-5xl grid justify-center text-[#ffa611]"><SiFirebase /></div>
                <div className="skill-card-border text-5xl grid justify-center text-[#0078d7]"><SiWindows /></div>
                <div className="skill-card-border text-5xl grid justify-center text-[#0078d7]"><SiVisualstudiocode /></div>
                <div className="skill-card-border text-5xl grid justify-center text-[#6567a5]"><SiHeroku /></div>
                <div className="skill-card-border text-5xl grid justify-center text-[#009999]"><SiNetlify /></div>
                <div className="skill-card-border text-5xl grid justify-center text-[#ef5b25]"><SiPostman /></div>
                <div className="skill-card-border text-5xl grid justify-center text-[#e32c26]"><AiFillHtml5 /></div>
                <div className="skill-card-border text-5xl grid justify-center text-[#2965f1]"><SiCss3 /></div>
                <div className="skill-card-border text-5xl grid justify-center text-[#756abc]"><SiRedux /></div>
                <div className="skill-card-border text-5xl grid justify-center text-[#3fa037]"><AiFillDatabase /></div>
                <div className="skill-card-border lg:text-5xl text-3xl grid justify-center h1p text-[#6772e5]"><h1>More</h1></div>





            </div>




        </div>
    );
};

export default Skill;